import { render, staticRenderFns } from "./NewJcdx.vue?vue&type=template&id=0840a45e&"
import script from "./NewJcdx.vue?vue&type=script&lang=js&"
export * from "./NewJcdx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewJcdx.vue"
export default component.exports